import {getLoginUrl} from './getURLs';

export const getOauthToken = async (uiFrontEndUrl: string, awsProxyUrl: string): Promise<void> => {
  window.location.href = getLoginUrl(uiFrontEndUrl, awsProxyUrl);
};
